import { Injectable, OnDestroy } from '@angular/core'
import gql from 'graphql-tag'
import { Subscription } from 'rxjs'
import { Apollo } from 'apollo-angular'
import { graphqlPatch, graphqlDelete } from '../mutation-helper'
import { errorToast } from '../../toaster'
import { MutationOptions } from 'apollo-client/core/watchQueryOptions'

// Want to make these mutations more dynamic.
// Better querying from mutations via method call vs static return values.

const updateUserPreferences = gql`
  mutation updateUserPreferencesMutation($input: UpdateUserPreferencesMutationInput!) {
    UpdateUserPreferencesMutation(input: $input) {
      errors
      user {
        uiPreferences {
          reminderBetterSubmissions
          showMigrationAlertOnLoad
        }
      }
    }
  }
`

const acceptTos = gql`
  mutation userAcceptTos($input: AcceptTosMutationInput!) {
    AcceptTosMutation(input: $input) {
      errors
      user {
        showTosMessage
      }
    }
  }
`


@Injectable({providedIn: 'root'})
export class UserMutations implements OnDestroy {
  private mutateSub: Subscription;

  constructor(private apollo: Apollo) {}

  updateUserPreferences(updates: object, options?: Partial<MutationOptions>): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.mutateSub) this.mutateSub.unsubscribe()
      this.mutateSub = this.apollo.mutate({
        mutation: updateUserPreferences,
        variables: {
          input: {
            patch: graphqlPatch(updates),
            delete: graphqlDelete(updates)
          }
        },
        ...(options || {})
      }).subscribe(({ data }: {data: any}) => {
        if (data && data.UpdateUserPreferencesMutation.errors) {
          data.UpdateUserPreferencesMutation.errors.forEach(e => errorToast(e))
        } else {
          if (data) {
            resolve(data)
          }
        }
      }, (error) => {
        errorToast(error)
        reject()
      })
    })
  }

  userAcceptTos(accept: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.mutateSub) this.mutateSub.unsubscribe()
      this.mutateSub = this.apollo.mutate({
        mutation: acceptTos,
        variables: {
          input: {
            accept: accept
          }
        }
      }).subscribe(({ data }: {data: any}) => {
        if (data?.AcceptTosMutation?.errors?.length > 0) {
          data.AcceptTosMutation.errors.forEach(e => errorToast(e))
        } else {
          if (data) {
            resolve(data)
          }
        }
      }, (error) => {
        errorToast(error)
        reject()
      })
    })
  }

  ngOnDestroy(): void {
    if (this.mutateSub) this.mutateSub.unsubscribe()
  }
}
